import actions from './actions';


const initState = {
    profile: null,
}


export default function userReducer(state=initState, action) {
    switch (action.type) {
        case actions.USER_LOADED_SUCCESS:
            return {...state, profile: action.user}
        default:
            return state;
    }

    return state;
}